import React from 'react';
import { Grid, TextField } from '@mui/material';

interface PlanChangeReasonFieldProps {
  planChangeReason: string;
  setPlanChangeReason: (reason: string) => void;
  show: boolean;
}

export const PlanChangeReasonField = ({
  planChangeReason,
  setPlanChangeReason,
  show,
}: PlanChangeReasonFieldProps) => {
  if (!show) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <TextField
        label="Plan Change Reason"
        rows={4}
        placeholder="Tell us why you're changing your plan..."
        value={planChangeReason}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setPlanChangeReason(e.target.value);
        }}
        required
        fullWidth
        multiline
        data-cy="plan-change-reason"
      />
    </Grid>
  );
};

